<template>
  <article class="news-container">
    <h1 class="news-title">{{ $t('newsinfo.proteinSystem.title') }}</h1>

    <div class="news-content">
      <div
        v-for="imageNumber in imageCount"
        :key="imageNumber"
        class="image-wrapper"
      >
        <img
          :src="`${imageBaseUrl}/${imageNumber}.jpg`"
          :alt="`${$t('newsinfo.proteinSystem.imageAlt')} ${imageNumber}`"
          loading="lazy"
        />
      </div>
    </div>
  </article>
</template>

<script setup>
const imageBaseUrl = 'https://www.healthcode.com/media/news/0819'
const imageCount = 11
</script>

<style scoped>
.news-container {
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
  padding: 30px 16px 60px;
  box-sizing: border-box;
  background: #fff;
  color: #333;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC",
    "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
}

.news-title {
  margin: 0 0 28px;
  color: #222;
  font-size: 24px;
  line-height: 1.45;
  text-align: center;
}

.news-content {
  width: 100%;
}

.image-wrapper {
  margin: 0 0 18px;
  text-align: center;
}

.image-wrapper:last-child {
  margin-bottom: 0;
}

.image-wrapper img {
  display: block;
  width: 100%;
  height: auto;
  margin: 0 auto;
}

@media (max-width: 480px) {
  .news-container {
    padding: 24px 10px 40px;
  }

  .news-title {
    margin-bottom: 22px;
    font-size: 20px;
  }

  .image-wrapper {
    margin-bottom: 12px;
  }
}
</style>
